'use client';
import { useQuery as useQuery$1 } from '@tanstack/react-query';
import { useComposeUseQueryOptions } from '../lib/useComposeUseQueryOptions.js';

const useQuery = (qraftOptions, schema, args)=>{
    return useQuery$1(// @ts-expect-error - Too complex to type
    ...useComposeUseQueryOptions(qraftOptions, schema, args, false));
};

export { useQuery };
//# sourceMappingURL=useQuery.js.map
